// User role definitions
export interface RoleOption {
  value: string;
  label: string;
}

export const USER_ROLES: RoleOption[] = [
  { value: 'doctor', label: 'Doctor' },
  { value: 'assistant', label: 'Assistant' },
  { value: 'org_admin', label: 'Organization Admin' },
];

// Helper function to get roles for filtering (all roles)
export const getFilterRoleOptions = (): RoleOption[] => USER_ROLES;

// Helper function to get roles for assignment (might exclude some system roles in the future)
export const getAssignableRoles = (): RoleOption[] => USER_ROLES;

// Helper function to find role label by value
export const getRoleLabelByValue = (value: string): string => {
  const role = USER_ROLES.find(role => role.value === value);
  return role?.label || value;
}; 